import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/logo-login.png";
import emailLogo from "../assets/images/email-logo.svg";
import { authStart, clearAuthFlow, setAuthFlowStep } from "../api/authApi";

export default function Login() {
  const navigate = useNavigate();

  const [partner, setPartner] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async () => {
    setError("");
    const trimmed = partner.trim();
    if (!trimmed) {
      setError("Partner ID is required");
      return;
    }

    try {
      setLoading(true);
      clearAuthFlow();
      const data = await authStart(trimmed);

      if (data.is_2fa_enabled === true) {
        setAuthFlowStep("totp_verify");
        navigate("/2fa/verify");
      } else {
        setAuthFlowStep("verify_email");
        navigate("/verify-email");
      }
    } catch (e) {
      setError(e?.message || "Login failed, please try again.");
    } finally {
      setLoading(false);
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") handleLogin();
  };

  return (
    <div className="min-h-screen bg-[#3d3935] flex flex-col items-center justify-center px-4">
      <div className="mb-8 text-center w-full mt-[10px] max-w-[240px] h-[130px]">
        <img src={logo} alt="" />
      </div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleLogin();
        }}
        className="w-full bg-white shadow-login px-[40px] pt-[15px] pb-[10px] max-w-[440px] mx-auto rounded-[8px] sm:rounded-[15px]"
      >
        <h1 className="text-[14px] font-semibold text-[#555] mt-[10px] mb-[15px] text-center">
          Please log in to your account
        </h1>

        <div className="relative my-2">
          <div className="pointer-events-none absolute w-[16px] left-[12px] top-1/2 -translate-y-1/2">
            <img src={emailLogo} alt="" />
          </div>

          <input
            type="text"
            name="username"
            autoComplete="username"
            autoFocus
            className="w-full bg-[rgba(234,231,231,0.5)] border border-[#cccccc] box-border text-[13px] text-[#6b6b6b] font-['Roboto',sans-serif] pl-[40px] pr-[20px] py-[15px] rounded-md outline-none transition duration-150 ease-in-out focus:border-[#212529] focus:shadow-[0_0_0_3px_rgba(0,0,0,0.08)] placeholder:text-[#5791BD]"
            placeholder="Partner ID"
            value={partner}
            onChange={(e) => setPartner(e.target.value)}
          />
        </div>

        {error && (
          <div className="mt-2 text-[12px] text-red-600 text-center">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className={`w-full h-[44px] text-white px-[20px] pt-[12px] pb-[14px] mt-[15px] mx-[2px] inline-block text-center rounded-[20px] text-[13px] cursor-pointer transition-opacity duration-150 ${
            loading
              ? "bg-[#cccccc] cursor-default opacity-60"
              : "bg-[#3d3935] border border-[#0f61a1] hover:opacity-80"
          }`}
        >
          {loading ? "Logging in..." : "Log in"}
        </button>
      </form>
    </div>
  );
}
